import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { CANDY_APPLE, OZ, OLAF } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
const BASE_CLASS_NAME = 'quiz-feedback';

const QuizFeedback = ({
  correctAnswer,
  onTryAgainClick,
  children
}) => /*#__PURE__*/_jsxs("div", {
  className: BASE_CLASS_NAME,
  "data-test-id": "quiz-feedback",
  "data-test-info-quiz-feedback": correctAnswer,
  children: [/*#__PURE__*/_jsxs("div", {
    className: `${BASE_CLASS_NAME}__header`,
    children: [/*#__PURE__*/_jsx(UIIconCircle, {
      backgroundColor: correctAnswer ? OZ : CANDY_APPLE,
      borderColor: correctAnswer ? OZ : CANDY_APPLE,
      color: OLAF,
      name: correctAnswer ? 'success' : 'remove',
      size: 12
    }), /*#__PURE__*/_jsx("div", {
      className: `${BASE_CLASS_NAME}__header-text--${correctAnswer ? 'correct' : 'incorrect'}`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.quiz.${correctAnswer ? 'thatsRight' : 'notQuite'}`
      })
    })]
  }), /*#__PURE__*/_jsx("div", {
    className: `${BASE_CLASS_NAME}__feedback-text`,
    children: children
  }), correctAnswer ? null : /*#__PURE__*/_jsx(UIButton, {
    className: "ignore-enter-proceed",
    "data-test-id": "quiz-feedback-retry",
    onClick: onTryAgainClick,
    use: "tertiary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.quiz.tryAgain"
    })
  })]
});

export default QuizFeedback;